/* unplugin-vue-components disabled */import { render } from "./MoblieStepType.vue?vue&type=template&id=2744e3e8"
import script from "./MoblieStepType.vue?vue&type=script&lang=js"
export * from "./MoblieStepType.vue?vue&type=script&lang=js"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__